import type { ReactElement } from 'react'
import { TextArea, TextInput } from './content-fields'
import type { Translate } from './content-types'
import { MarkdownPreviewView } from './markdown-preview.view'

/**
 * Props for {@link DraftEditorView}.
 *
 * @property errors - Translated messages for `title` and `body`.
 * @property readOnly - Renders the inputs disabled (no `content.write`).
 */
export interface DraftEditorViewProps {
	t: Translate
	title: string
	body: string
	errors: Record<string, string>
	readOnly?: boolean
	onChange: (field: 'title' | 'body', value: string) => void
}

/** Title + Markdown body with a live preview beside it (organism). */
export function DraftEditorView(props: DraftEditorViewProps): ReactElement {
	const { t } = props
	return (
		<div className="grid gap-4 md:grid-cols-2">
			<div className="flex flex-col gap-3">
				<TextInput
					label={t('editor.title')}
					value={props.title}
					error={props.errors.title}
					disabled={props.readOnly}
					onChange={(v) => props.onChange('title', v)}
				/>
				<TextArea
					label={t('editor.body')}
					description={t('editor.bodyHint')}
					value={props.body}
					error={props.errors.body}
					disabled={props.readOnly}
					onChange={(v) => props.onChange('body', v)}
				/>
			</div>
			<MarkdownPreviewView label={t('editor.preview')} markdown={props.body} />
		</div>
	)
}
